import { ChatLocalMesage } from '@packages/chat'
import { useEffect, useState } from 'react'
import { useChatContext } from 'stream-chat-react'

export const usePinnedMessage = (channelId: string, channelType: string) => {
  const { client: chatClient } = useChatContext()
  const [pinnedMessage, setPinnedMessage] = useState<ChatLocalMesage>(null)

  useEffect(() => {
    if (!chatClient || !channelId || !channelType) return

    const channel = chatClient?.channel(channelType, channelId)
    if (!channel) return

    const currentPinned = channel.state.pinnedMessages?.[0] || null
    setPinnedMessage(currentPinned)

    const handleEvent = () => {
      const updatedChannel = chatClient?.channel(channelType, channelId)
      setPinnedMessage(updatedChannel.state.pinnedMessages?.[0] || null)
    }

    channel.on('message.updated', handleEvent)

    return () => {
      channel.off('message.updated', handleEvent)
    }
  }, [chatClient, channelId, channelType])

  return {
    pinnedMessage,
  }
}
